import { Component, OnInit } from "@angular/core";
import { FDomiciliacionService } from "../../servicios/f-domiciliacion.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem } from "primeng/api";
import { FDomiciliacion , FDomiciliacionInput} from "../../entidades/entidades";
import { ExportExcelService } from '../../servicios/exportExcel.service';
import { ExportTxtService } from '../../servicios/exportTxt.service';
@Component({
  selector: "app-fdomiciliacion-grid",
  templateUrl: "./fdomiciliacion-grid.component.html",
  styleUrls: ["./fdomiciliacion-grid.component.css"],
})
export class FDomiciliacionGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  fDomiciliacion: FDomiciliacion[];
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  fDomiciliacionInput = new FDomiciliacionInput();
  public progressBar = false;
  constructor(
   private fDomiciliacionService: FDomiciliacionService,
   private exportExcelService: ExportExcelService,
   private exportTxtService: ExportTxtService,
  ) {}

  ngOnInit(): void {
    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      {label: "Excel", icon: "pi pi-file-excel", command: (event) => {this.exportToExcel();} },
      {label: "txt", icon: "pi pi-file-o", command: (event) => {this.exportToTxt();} },
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "id", header: "Referencia",ordenar: false, styleHeader: "width: 90px;",},
      {field: "importeSinIva", header: "Importe sin IVA",ordenar: true, styleHeader: "width: 150px;",},
      {field: "iva", header: "IVA",ordenar: true, styleHeader: "width: 80px;",},
      {field: "referenciaNumerica", header: "Referencia numerica",ordenar: true, styleHeader: "width: 100px;",},
      {field: "titularServicio", header: "Titular del servicio",ordenar: true, styleHeader: "width: 300px;",},
      {field: "banco", header: "Banco",ordenar: true, styleHeader: "width: 100px;",},
      {field: "tipoCuenta", header: "Tipo de cuenta",ordenar: true, styleHeader: "width: 80px;",},
      {field: "clabe", header: "CLABE",ordenar: true, styleHeader: "width: 180px;",},
      {field: "titularCuenta", header: "Titular de la cuenta",ordenar: true, styleHeader: "width: 300px;",},
    ];

    this.fDomiciliacionInput.fechaIni = new Date(); 
    this.fDomiciliacionInput.fechaFin = new Date(); 
    console.log('this.fDomiciliacionInput', this.fDomiciliacionInput);
  }

  async getAllFDomiciliacion() {
    try {
      this.progressBar = true;
      const datoRetorno = await this.fDomiciliacionService.getBusquedas(this.fDomiciliacionInput).toPromise();
      console.log('datoRetorno', datoRetorno);
      this.fDomiciliacion = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      this.progressBar = false;
      console.log("Paso por getAllFDomiciliacion");
    }
  }


  //===============================================================
  //Interaccion con servicios
  //===============================================================
  async guardarGridFDomiciliacion() {
    try {
      for (let fDomiciliacionFor of this.fDomiciliacion) {
        if (fDomiciliacionFor.baja) {
          await this.deleteFDomiciliacion(fDomiciliacionFor);
        } else if (fDomiciliacionFor.cambio) {
          fDomiciliacionFor.cambio = false;
          if (fDomiciliacionFor.id === 0) {
            const datoRetorno = await this.addFDomiciliacion(fDomiciliacionFor);
            fDomiciliacionFor.id = datoRetorno.id;
          } else {
            await this.updateFDomiciliacion(fDomiciliacionFor);
          }
        }
      }

      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarFDomiciliacion");
    }
  }

  async addFDomiciliacion(fDomiciliacion) {
    try {
      const datoretorno = await this.fDomiciliacionService
        .add(fDomiciliacion)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addFDomiciliacion");
    }
  }

  async updateFDomiciliacion(fDomiciliacion: FDomiciliacion) {
    try {
      const datoRetorno = await this.fDomiciliacionService
        .update(fDomiciliacion)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateFDomiciliacion");
    }
  }

  async deleteFDomiciliacion(fDomiciliacion: FDomiciliacion) {
    try {
      const datoRetorno = await this.fDomiciliacionService
        .delete(fDomiciliacion.id)
        .toPromise();
      this.getAllFDomiciliacion();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteFDomiciliacion");
    }
  }
 
  exportToExcel() {

    const dataToExport = this.fDomiciliacion.map(item => ({
      'Referencia': item.id,
      'Importe sin IVA': item.importeSinIva,
      'IVA': item.iva,
      'Referencia Numérica': item.referenciaNumerica,
      'Titular del servicio': item.titularServicio,
      'Banco':item.banco,
      'Tipo de cuenta':item.titularCuenta,
      'CLABE':item.clabe,
      'Titular de la cuenta':item.titularCuenta
    }));
    
    const formatter = new Intl.DateTimeFormat('es-MX',  {year: 'numeric', month: '2-digit',day: '2-digit'});
    const fechaIni = formatter.format(this.fDomiciliacionInput.fechaIni);
    const fechafin = formatter.format(this.fDomiciliacionInput.fechaFin);
    let NombreArchivo = 'Domiciliaciones' + fechaIni + 'al' + fechafin;

    this.exportExcelService.exportAsExcelFile(dataToExport, NombreArchivo);
  }

  exportToTxt(): void {
    const headers = [];
    const dataToExport = this.fDomiciliacion.map(item => ({
      '': item.txt,
    }));

    const formatter = new Intl.DateTimeFormat('es-MX',  {year: 'numeric', month: '2-digit',day: '2-digit'});
    const fechaIni = formatter.format(this.fDomiciliacionInput.fechaIni);
    const fechafin = formatter.format(this.fDomiciliacionInput.fechaFin);
    let NombreArchivo = 'Domiciliaciones' + fechaIni + 'al' + fechafin;

    this.exportTxtService.exportAsTxtFile(dataToExport, NombreArchivo, headers);
  }

}